import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DataGrid } from '@material-ui/data-grid';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import { TemplateApi } from '../../apis/index';

const Template = (props) => {
  const [templates, setTemplates] = useState([]);

  const getTemplateList = async () => {
    const res = await TemplateApi.getTemplate();
    setTemplates(res.data);
  };

  useEffect(() => {
    getTemplateList();
  }, []);

  let columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'templateName',
      headerName: 'Template Name',
      width: 480,
    },
    {
      field: 'dispenser1FlowRate',
      headerName: 'dispenser1FlowRate',
      width: 185,
      valueFormatter: (params) =>
        params.row.scaffoldProperty.dispenser1FlowRate,
    },
    {
      field: 'ink1NeedleLength',
      headerName: 'dispenser1Layer0FlowRate',
      width: 230,
      valueFormatter: (params) =>
        params.row.scaffoldProperty.dispenser1Layer0FlowRate,
    },
    {
      field: 'invivoSpec',
      headerName: 'INVIVO Spec',
      width: 135,
      valueFormatter: (params) => params.row.kitInfo.invivoSpec,
    },
  ];

  const addColumnsData = (columns) => {
    const addDesign = {
      sortable: false,
      headerAlign: 'center',
      align: 'center',
    };
    for (let i in columns) {
      columns[i] = { ...columns[i], ...addDesign };
    }
    return columns;
  };

  const handleChangeValue = async (e) => {
    const value = e.target.value.toString().trim();
    let res;

    if (value.length === 0) {
      res = await TemplateApi.getTemplate();
      setTemplates(res.data);
    } else {
      res = await TemplateApi.getTemplateBySearch(value);
      setTemplates(res.data);
    }
  };

  const handleRowSelection = (e) => {
    props.history.push('/updateTemplate/' + e.row.id);
  };

  return (
    <>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="title">TEMPLATE LIST</div>
          <button>
            <Link to="/saveTemplate">
              <VaccinesIcon
                label="template"
                style={{
                  color: 'rgb(63, 89, 140)',
                  opacity: '90%',
                }}
              ></VaccinesIcon>
              <button className="blue">New Template</button>
            </Link>
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <TextField
            label="Search Template Name"
            onChange={handleChangeValue}
            style={{ paddingBottom: 30, width: '95%' }}
          />
          <SearchIcon />
        </div>
      </div>
      <div style={{ height: '650px', width: '100%' }}>
        <DataGrid
          rows={templates}
          columns={addColumnsData(columns)}
          autoPageSize={true}
          disableColumnMenu
          onRowClick={handleRowSelection}
        />
      </div>
    </>
  );
};

export default Template;
